import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API, AreaDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { TableWrapperOptions } from '../../../../services/global/global-interfaces';
import { PermissionService } from '../../../../services/permission.service';
import { StringTransformationService } from 'src/app/services/transformation-helper/string-transformation.service';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-page-company-details-areas',
  templateUrl: './company-details-areas.component.html',
  styleUrls: ['./company-details-areas.component.scss'],
  standalone: false,
})
export class CompanyDetailsAreasComponent implements OnInit {
  readonly stringTransformation = inject(StringTransformationService);
  private readonly destroyRef = inject(DestroyRef);
  companyId: number;
  loading: boolean;

  areas: AreaDTO[];
  debounceTimer: ReturnType<typeof setTimeout>;
  options: TableWrapperOptions;

  constructor(
    private readonly api: API,
    private readonly activatedRoute: ActivatedRoute,
    public readonly util: UtilService,
    public readonly errorHandler: ErrorService,
    public readonly permissionService: PermissionService
  ) {
    this.companyId = undefined;
    this.loading = true;
    this.areas = [];
    this.debounceTimer = null;
  }

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.companyId = +params.companyID;
    });
  }

  requestDebounced(options?: TableWrapperOptions) {
    if (options) {
      this.options = options;
    }

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.refreshFromServer();
    }, 500);
  }

  refreshFromServer() {
    this.loading = true;
    if (this.options?.pagination) {
      this.api
        .dm_geo_Area_retrieveAll(
          {
            search: this.stringTransformation.encodeSearchQueryParam(this.options.exactMatch, this.options.search),
            company: [this.companyId],
            hasCompany: true,
          },
          this.options.pagination
        )
        .pipe(
          take(1),
          takeUntilDestroyed(this.destroyRef),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: (res: AreaDTO[]) => {
            this.areas = res;
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }
}
